import { type IAPIProxy, defaultPostHeaderForJsonData } from "@inwink/apibase";
import { oidcmgr } from "@inwink/apibase/auth/oidc-manager";
import type { IFileInputManager } from "@inwink/fileutils/fileapi";
import { combine } from "@inwink/utils/url";

export function fileInputManager(shardingKey: string, apiproxy: IAPIProxy, fileUrlBuilder: (entity: string) => string = null) {
    const urlBuilder = fileUrlBuilder ?? function (entity: string) {
        return `${shardingKey}/${entity}/file`;
    };
    const res: IFileInputManager = {
        createTmpFile(model: {
            entity: string,
            field: string,
            type: string,
            name: string
        }) {
            const url = urlBuilder(model.entity);
            // const url = (customPath
            //     ? `${shardingKey}/${customPath}/${model.entity}/file`
            //     : `${shardingKey}/${model.entity}/file`);
            return apiproxy.postJson(url, JSON.stringify(model), defaultPostHeaderForJsonData);
        },

        renewTmpAccessFile(model: {
            blobName: string,
            entity: string,
            field: string,
            type: string,
            name: string
        }) {
            const url = combine(urlBuilder(model.entity), `/renew`);
            // const url = (customPath
            //     ? `${shardingKey}/${customPath}/${model.entity}/file/renew`
            //     : `${shardingKey}/${model.entity}/file/renew`);
            return apiproxy.postJson(url, JSON.stringify(model), defaultPostHeaderForJsonData);
        },

        tryRenewTmpAccessFile(model: {
            sas: string,
            blobName: string,
            entity: string,
            field: string,
            type: string,
            name: string
        }) {
            const url = combine(urlBuilder(model.entity), `/try-renew`);
            // const url = (customPath
            //     ? `${shardingKey}/${customPath}/${model.entity}/file/try-renew`
            //     : `${shardingKey}/${model.entity}/file/try-renew`);
            return apiproxy.postJson(url, JSON.stringify(model), defaultPostHeaderForJsonData).then((result) => {
                return result.status === 204 ? null : result;
            }, (error) => {
                return Promise.reject(error);
            });
        },

        getFileAccess(entity: string, field: string, entityId: string, lang: string, withoutExpiration?: boolean) {
            let url = combine(urlBuilder(entity), `/${entityId}/${field}?lang=${lang || ''}`);
            // let url = (customPath
            //     ? `${shardingKey}/${customPath}/${entity}/file/${entityId}/${field}?lang=${lang || ''}`
            //     : `${shardingKey}/${entity}/file/${entityId}/${field}?lang=${lang || ''}`);
            if (withoutExpiration) {
                url = `${url}&withoutExpiration=${withoutExpiration}`;
            }
            return apiproxy.getJson(url, null);
        },

        copyToTmp(eventId: string, entityName: string, entityId: string, fieldKey: string) {
            const url = `${eventId}/${entityName}/file/${entityId}/${fieldKey}/copytotmp`;
            return apiproxy.getJson(url);
        },

        getStatus(entity: string, field: string, entityId: string) {
            const url = combine(urlBuilder(entity), `/${entityId}/${field}/status`);
            // const url = (customPath
            //     ? `${shardingKey}/${customPath}/${entity}/file/${entityId}/${field}/status`
            //     : `${shardingKey}/${entity}/file/${entityId}/${field}/status`);
            return apiproxy.getJson(url, null);
        },

        retryVideoEncoding(entity, field, entityId) {
            const url = combine(urlBuilder(entity), `/${entityId}/${field}/encoding/retry`);
            return apiproxy.postJson(url, JSON.stringify({
            }), defaultPostHeaderForJsonData);
        },

        // enabledFileVideoTranscript(entity: string, field: string, entityId: string, enabled: boolean) {
        //     const url = combine(urlBuilder(entity), `/filevideo/${entityId}/${field}transcripts/enabled`);
        //     // const url = (customPath
        //     //     ? `${shardingKey}/${customPath}/${entity}/file/filevideo/${entityId}/${field}transcripts/enabled`
        //     //     : `${shardingKey}/${entity}/file/filevideo/${entityId}/${field}/transcripts/enabled`);
        //     return apiproxy.postJson(url, JSON.stringify({
        //         enabled: enabled
        //     }), defaultPostHeaderForJsonData);
        // },

        // setFileVideoTranscriptLangs(entity: string, field: string, entityId: string, langs: string[]) {
        //     const url = combine(urlBuilder(entity), `/filevideo/${entityId}/${field}/transcripts`);
        //     // const url = (customPath ? `${shardingKey}/${customPath}/${entity}/file/filevideo/${entityId}/${field}transcripts`
        //     //     : `${shardingKey}/${entity}/file/filevideo/${entityId}/${field}/transcripts`);
        //     return apiproxy.postJson(url, JSON.stringify({
        //         langs: langs
        //     }), defaultPostHeaderForJsonData);
        // },

        // setFileVideoTranscriptLangContent(entity: string, field: string, entityId: string, lang: string, content: string) {
        //     const url = combine(urlBuilder(entity), `filevideo/${entityId}/${field}transcripts/${lang}`);
        //     // const url = (customPath
        //     //     ? `${shardingKey}/${customPath}/${entity}/file/filevideo/${entityId}/${field}transcripts/${lang}`
        //     //     : `${shardingKey}/${entity}/file/filevideo/${entityId}/${field}/transcripts/${lang}`);
        //     return apiproxy.postJson(url, JSON.stringify({
        //         content: content
        //     }), defaultPostHeaderForJsonData);
        // },

        getTranscriptManifest(entity: string, field: string, entityId: string) {
            const url = combine(shardingKey, `${entity}/file/video/${entityId}/${field}/transcripts/manifest`);
            return apiproxy.getJson(url);
        },

        setTranscriptManifest(entity: string, field: string, entityId: string, manifest: any) {
            const url = combine(shardingKey, `${entity}/file/video/${entityId}/${field}/transcripts/manifest`);
            return apiproxy.postJson(url, JSON.stringify(manifest), defaultPostHeaderForJsonData);
        },

        getTranscript(entity: string, field: string, entityId: string, language: string) {
            const url = combine(shardingKey, `${entity}/file/video/${entityId}/${field}/transcripts/${language}`);
            return apiproxy.getJson(url);
        },

        setTranscript(entity: string, field: string, entityId: string, language: string, transcript: any) {
            const url = combine(shardingKey, `${entity}/file/video/${entityId}/${field}/transcripts/${language}`);
            return apiproxy.postJson(url, JSON.stringify(transcript), defaultPostHeaderForJsonData);
        },

        deleteTranscript(entity: string, field: string, entityId: string, language: string) {
            const url = combine(shardingKey, `${entity}/file/video/${entityId}/${field}/transcripts/${language}/delete`);
            return apiproxy.postJson(url, JSON.stringify({}), defaultPostHeaderForJsonData);
        },

        getCaptions(entity, field, entityId) {
            const url = combine(shardingKey, `/file/video/${entity}/${entityId}/${field}/captions`);
            return apiproxy.getJson(url);
            // return Promise.resolve(combine(apiproxy.baseUrl, shardingKey, `/file/video/${entity}/${entityId}/${field}/captions`));
        },

        getDashVideoAccessUrl(entity: string, field: string, entityId: string) {
            return Promise.resolve(combine(apiproxy.baseUrl, shardingKey,
                `/file/video/${entity}/${entityId}/${field}/master.mpd`));
        },

        getHlsVideoAccessUrl(entity: string, field: string, entityId: string) {
            return Promise.resolve(combine(apiproxy.baseUrl, shardingKey,
                `/file/video/${entity}/${entityId}/${field}/master.m3u8`));
        },

        getRequestManifestHeaders() {
            if (inwink.config.clientConfig.authMode === 'cookies') return {};
            return {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "Authorization": () => oidcmgr.getToken().then((token) => `Bearer ${token}`)
            };
        },

        finalizeTmpFile(entity: string, blobModel: {
            sas?: string;
            blobName?: string;
        }) {
            const url = combine(urlBuilder(entity), 'finalize-tmp');
            return apiproxy.postJson(url, JSON.stringify(blobModel), defaultPostHeaderForJsonData).then((result) => {
                if (result.status === 200) {
                    return Promise.resolve();
                } else {
                    return Promise.reject();
                }
            }, (error) => {
                return Promise.reject(error);
            });
        }
    };

    return res;
}
